const EMAIL_CADENCE = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
};

export default EMAIL_CADENCE;
